import { render } from "./Paginator.vue?vue&type=template&id=08b98c50"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"

import exportComponent from "/Users/assetkhaitbay/Dev/local/laravelprocess/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__